import { Injectable } from '@angular/core';
import { List } from 'immutable';
import {
  ISearchParams,
  SearchParamsEnum,
  SortByEnum,
  SortOrderEnum,
} from '../../../entity-data/entity-data.data';
import { IMasterListHeader } from '../../../entity-master/components/master-list/master-list.interface';

@Injectable()
export class SearchListBuilder {
  constructor() {}

  buildSortParams(sortBy: SortByEnum, sortOrder: SortOrderEnum): ISearchParams {
    return {
      [SearchParamsEnum.sort_by]: sortBy,
      [SearchParamsEnum.sort_order]: sortOrder,
    };
  }

  buildSortByHeader(
    headers: List<IMasterListHeader>,
    params: ISearchParams
  ): IMasterListHeader {
    const sortBy = headers.find(
      (header) => header.sortBy === params[SearchParamsEnum.sort_by]
    );

    return {
      ...sortBy,
      sortOrder: params[SearchParamsEnum.sort_order],
    };
  }
}
